// extracted by mini-css-extract-plugin
export default {"body":"News_body__BUG76","header":"News_header__rvQ1K","gobackBox":"News_gobackBox__SmnNG","newsBox":"News_newsBox__pa234"};